import { environment } from "src/environments/environment"

export class urls {
    static SERVER_URL = environment.baseUrl
    static REPORT_SERVER_URL = environment.reportServerUrl
    static BASE_REPORT_SERVER_URL = environment.reportServerUrl+ 'api/'
    static PROVIDER_PANEL_URL = environment.PROVIDER_PANEL_URL

    static BASE_URL = environment.baseUrl + 'api/'
    static SIGNIN_URL = 'auth/signin'
    static FORGOT_URL = 'auth/forgot'
    static PROFILE_URL = 'users/me'
    // static STAFF_URL = 'staffs'
    static STAFF_URL = 'quarterpanels'

    static CHANGE_PASSWORD_URL = 'users/password'
    static CHANGE_PROFILE_IMAGE = 'users/picture'
    static NOTIFICATIONS_URL = 'notifications'
    static COPORATE_USER_LIST_URL = 'cooperates'
    static ADD_VEHICLE_EXPENSE_SERVICE_URL = 'maintenances/services'
    static GET_NEMT_PRO_TIPS_URL = 'protips'
    static GET_UNASSIGN_TRIPS_URL = 'assigns'
    static GET_ADJUSTED_TRIPS_URL = 'adjusttrips'
    static GET_OUTSTANDING_TRIPS_URL = 'assigns/outstanding'
    static GET_BULKWRITE_TRIPS_URL = 'assigns/lines'
    static ASSIGN_MULTIPLE_TRIPS_URL = 'assigns/selectedtrips'
    static GET_ASSIGNED_TRIPS_LIST = 'assigns/corporate'
    static VERIFIED_CANCEL_TRIP_URL = 'assigns/verifiedcancelled'
    static GENRATE_TRIP_SIGNATURE_URL = 'assigns/canvasSignature'
    static SINGLE_TRIP = 'assigns/singletrip'
    static MARK_COMPLETED_TRIP = "assigns/markcompleted"
    static GENERATE_TRIPS_REPORT = "assigns/assignedtripsexcel"
    static GET_CORPORATE_USER_LIST = 'cooperates'
    static CREATE_NEW_TRIP_URL = 'assigns'
    static NEMT_STATISTICS_URL = 'kpis/jobs/stats'
    static NEMT_REPORTS_URL = 'kpis'
    static ADMIN_NEMT_REPORTS_URL = 'companies'
    static NEMT_STATISTICS_DETAIL_BY_MEMBER_ID_URL = 'kpis/jobs/statsdetails'
    static GET_REPORTS_URL = 'reports/company/'
    static GET_TRIP_DETAILS_URL = 'dispatches'
    static GET_COMPLETED_TRIP_DETAIL = 'assigns/jobbyid?assignId='
    static GET_ADJUSTMENT_DETAIL_URL = 'jobs/adjustment/'
    static GET_ADJUSTMENT_DETAIL_TRIPSLOGS_URL = 'adjusttrips/'
    static TRIPS_FOR_ASSIGN_DASHBOARD_URL = 'assigns/dashboard'
    static NEMT_STAT_REPORT_PDF_URL = 'kpis/kpistatsreport'
    static NEMT_STAT_TRIP_REPORT_XLS_URL = 'kpis/kpitripsreport'
    static NEMT_BUSSINESS_REPORT_PDF_URL = 'kpis/businesskpi'
    static NEMT_GMT_KPI_REPORT_PDF_URL = 'kpis/gmt'
    static NEMT_DRIVER_KPI_REPORT_PDF_URL = 'kpis/driverkpi'
    static NEMT_BROKER_REPORT_PDF_URL = 'kpis/brokerkpi'
    static NEMT_CORPORATE_REPORT_PDF_URL = 'kpis/corporatekpi'
    static NEMT_CORPORATE_TRIP_REPORT_PDF_URL = 'kpis/corporateTrips'
    static NEMT_DRIVER_REPORT_PDF_URL = 'kpis/driverkpi'
    static GET_DRIVER_PDF_REPORT_URL = 'reports/driver/'
    static GET_PAYMENT_PDF_REPORT_URL = 'reports/admin/'
    static GET_ADMIN_EARNING_DETAILS_URL = 'reports/admin'
    static GET_BROKER_RATE_URL = 'assigns/jobbyid?assignId='
    static SCRAP_TRIPS_URL = 'assigns/scrap'
    static DRIVER_BREAKDOWN_URL = 'kpis/bussiness'
    static GET_SWEEP_TRIPS_LIST_URL = 'assigns/parselist'
    static SEND_TRIP_LIST_EMAIL_URL = 'assigns/files/'
    static FACILITY_TRIPS_URL = 'facilitytrips'
    static MEMBER_URL = 'members'
    static CLIENT_URL = 'clients'
    static EXPENSE_URL = 'expenses'
    static TRACKING_SMS_URL = 'trackingsms'
    static GET_CTC_TRIPS = 'brokersettings/ctc'
    static GET_MTM_TRIPS = 'brokersettings/mtm'
    static GET_KAISER_TRIPS = 'brokersettings/kaiser'
    static BROKER_SETTING_URL = 'brokersettings'
    static GET_COMPANIES_LIST = 'companies'
    static GET_INVOICE_LIST = 'companies'
    static GET_COMPANY_DATA_URL = 'providerinvoicesettings'
    static GET_TRIP_ASSISTANCE_LIST = 'tripassistances'
    static GET_NEMT_CODES = 'nemtcodes'
    static CMS_1500_CODES = 'cms1500s'
    static SEND_DRIVER_MANIFEST = 'assigns/senddrivermanifest'
    static GET_KPI_SCORE = 'kpis/score'
    static GET_MANIFEST_TRIPS = 'assigns/getmanifesttrips'
    static GET_TRIP_PURPOSES = 'purposes'
    static LEVEL_OF_SERVICE = 'vehicles'
    static TP_LEVEL_OF_SERVICE = 'tpvehicles'
    static GET_COMPANY_TOKEN = 'getCompanyToken'
    static DOCUMENTS = 'documents'
    static LEVEL_OF_SERVICE_URL = 'levelofservices'
    static SPACE_TYPE_URL = 'spacetypes'
    static CORPORATE_BROKERS = 'cooperates/brokers'
    static SPACE_TYPE_MAPPERS = 'spacetypemappers'
    static CALCULATE_ESTIMATE_FARE = 'assigns/tempestimatedfare'
    static DRIVER_BREAK = 'assigns/addupdatebreak'
    static TRIP_ACTIVITY_LOG ='assigns/activitylogs'
    static FARE_FORMULA = 'jobs/formula'
    static EDIREPORTS = 'edireports'
    static GET_ALARMING_TRIPS = 'assigns/alarmingtrips'
    static GET_OPERATIONS = 'assigns/operations'
    static GET_NEARBY_DRIVER_URL = 'drivers/nearby'
    static ADD_DRIVER_URL = 'drivers'
    static DRIVERS_URL = 'drivers/companies'
    static DRIVER_RESET_PASSWORD_URL = 'drivers/resetpassword'
    static QUERIES_URL = 'queries'
    static DRIVERS_SMS_URL = 'driveralerts?receiver='
    static DRIVER_GENERATE_QR_URL = 'drivers/generateqr'
    static DRIVER_CALCULATE_INVOICE_URL = 'driverinvoices'
    static DRIVER_TIMELINES_URL = 'timelines'
    static GET_STATISTICS = 'assigns/insurancepanelstats'
     static SERVICE_AREAS = 'serviceareas'
    static CONFIGURATIONS = 'configurations'

    static MODIFIER_CODES_URL = 'modifiers'
    static PRIMARY_DIAGNOSE_URL = 'nemtcodes'
    static EQUIPMENT_URL = 'equipments'

}
